import React from 'react';
import Path from '@grebban/react-core-components/svg/Path';
import Svg from '@grebban/react-core-components/svg/Svg';

interface ZoomIconProps {
    color?: string;
    width?: string;
    height?: string;
}

export const ZoomIcon = ({ color = 'currentColor', width = '18px', height = '18px' }: ZoomIconProps) => (
    <Svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <Path d="M1 7V1H7" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <Path d="M17 11V17H11" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
);
